import groq from 'groq'
import pageFields from '../fields/page'
import contentField from '../fields/content'

export default (slug, id) => groq`
  *[_id == "${id}" || _type == "page" && slug.current == "${slug}"][0]{
    ...${pageFields},
    content[]{
      ...${contentField}
    },
    nonCBDContent[]{
      ...${contentField}
    }
  }
`
